'use strict';

var _ = require('lodash');
var CityToPosMapper = function CityToPosMapper(configurationService) {
  function getCountry(city) {
    var airportRegionMapping = _.find(configurationService.getFoAirportRegionMapping(), {
      cityCode: city
    });
    if (airportRegionMapping) {
      return airportRegionMapping.pos;
    }
    return undefined;
  }
  return {
    getCountry: getCountry
  };
};
CityToPosMapper.$inject = ['ConfigurationService'];
module.exports = CityToPosMapper;